import { AxiosResponse } from 'axios'
import { axiosWithAuth, axiosWithImitator } from '../withAuth'
import { mapWorkplaces, Workplace } from '../../models/Workplace'

// /opslagsdata/hentstillingfaggruppesektorlister
const getPositionsAndGroups = async (): Promise<any> => {
    const response = await axiosWithImitator.get(
        `/opslagsdata/hentstillingfaggruppesektorlister`
    )

    const { data } = response
    return data
}

// /opslagsdata/henttrarbejdsstederogstillinger
const getWorkplacesAndPositions = async (): Promise<{
    workPlaces: Workplace[]
}> => {
    const response = await axiosWithImitator.get(
        `/opslagsdata/henttrarbejdsstederogstillinger`
    )

    const { data } = response
    return {
        workPlaces: mapWorkplaces(data.Arbejdssteder),
    }
}

const userIsActiveInApp = async (): Promise<any> => {
    const response = await axiosWithImitator.post(`/profil/brugeraktiviapp`)

    const { data } = response
    return data
}

export { getPositionsAndGroups, getWorkplacesAndPositions, userIsActiveInApp }
